export default "__VITE_ASSET__DavJya8c__"